import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Heading, Text } from '@sendible/design-system';
import { useRequestWorkspaceAccess } from '@sendible/frontendv2/src/models/workspaceAccess';
import { ButtonGroup, Container, Content, SignedInAsCard, TextGroup } from './index.styles';

export const NoWorkspaceAccessPage: FC = () => {
  const { t } = useTranslation('workspace_access');
  // Rendered before the app shell (and its shared-state bridge) has finished initialising, so this
  // reads the signed-in user directly from the legacy login context rather than via useBridgeContext.
  const defaultLoginDetails = window.loginContext?.getDefaultLoginDetails();
  const { mutate: requestAccess, isPending, isSuccess } = useRequestWorkspaceAccess(defaultLoginDetails?.accessToken);
  const email = defaultLoginDetails?.email;

  return (
    <Container>
      <Content>
        <img
          src="/img/logo_2025.svg"
          alt="Sendible"
          style={{ height: '30px', width: 'auto' }}
        />
        {email && (
          <SignedInAsCard>
            <Text variation="body_12">{t('signed_in_as')}</Text>
            <Text variation="body_14">
              <strong>{email}</strong>
            </Text>
          </SignedInAsCard>
        )}
        {isSuccess ? (
          <TextGroup>
            <Heading
              semantic="h1"
              variation="layout-title_32"
            >
              {t('request_sent')}
            </Heading>
            <Text>{t('request_sent_description')}</Text>
          </TextGroup>
        ) : (
          <>
            <TextGroup>
              <Heading
                semantic="h1"
                variation="layout-title_32"
              >
                {t('access_needed')}
              </Heading>
              <Text>{t('access_needed_description')}</Text>
            </TextGroup>
            <ButtonGroup>
              <Button
                appearance="primary"
                variation="fill"
                size={16}
                label={t('request_access')}
                isLoading={isPending}
                disabled={isPending}
                onClick={() => requestAccess()}
              />
              <Button
                appearance="default"
                variation="outline"
                size={16}
                label={t('switch_accounts')}
                onClick={() => window.loginContext?.signout()}
              />
            </ButtonGroup>
          </>
        )}
      </Content>
    </Container>
  );
};

export default NoWorkspaceAccessPage;
